<ng-container *ngIf="customer$ | async as customer">
  <header class="customer">
    <div>
      <h2 class="customer__name">{{ customer.name }}</h2>
      <p class="customer__email">{{ customer.email }}</p>
      <p class="customer__city">{{ customer.city }}</p>
    </div>
    <div>
      <img *ngIf="customer.imageStr"
        class="customer__image"
        src="{{ customer.imageStr }}"
      />
      <address>
        <span class="customer__address">{{ customer.address }}</span>
      </address>
    </div>
  </header>
</ng-container>
